import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { ILocation } from '../location-modal/location-modal.interfaces';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-location-picker-modal',
  templateUrl: './location-picker-modal.component.html',
  styleUrls: ['./location-picker-modal.component.css']
})
export class LocationPickerModalComponent implements OnInit {
  initialLocation: ILocation = {};
  selectedLatitude: any = 40.4168; // Default coordinates for Madrid
  selectedLongitude: any = -3.7038;
  latitude: number = 40.4168; // Default coordinates for Madrid
  longitude: number = -3.7038;
  zoom: number = 14; // Default zoom level
  address: string = '';
  private geoCoder!: google.maps.Geocoder;
  dialog: MatDialogRef<any>;

  @ViewChild('search') searchElementRef!: ElementRef;

  constructor(
    private ngZone: NgZone,
    public dialogRef: MatDialogRef<any>,
    public alertService: AlertService
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {
    // Initialize Geocoder
    this.geoCoder = new google.maps.Geocoder();
    this.setInitialLocation();
  }

  ngAfterViewInit() {
    // Ensure @ViewChild is available
    this.initializeAutocomplete();
  }
  
  initializeAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (place.geometry && place.geometry.location) {
          this.selectedLatitude = place.geometry.location.lat();
          this.selectedLongitude = place.geometry.location.lng();
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 14;
          this.getAddress(this.latitude, this.longitude);
        }
      });
    });
  }

  setInitialLocation(): void {
    const [lat, long] = (this.initialLocation.coordinates || []);
    this.latitude = lat || 40.4168;
    this.longitude = long || -3.7038;
    this.selectedLatitude = this.latitude;
    this.selectedLongitude = this.longitude;
    this.zoom = 14;
    this.getAddress(this.latitude, this.longitude);
  }

  async getAddress(latitude: number, longitude: number) {
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results: any, status: any) => {
      if (status === 'OK' && results[0]) {
        this.address = results[0].formatted_address;
      } else {
        console.error('Geocoder failed due to:', status);
      }
    });
  }

  resetSelection() {
    this.selectedLongitude = null;
    this.selectedLatitude = null;
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.ngZone.run(() => {
        this.selectedLatitude = event.latLng?.lat();
        this.selectedLongitude = event.latLng?.lng();
        this.latitude = this.selectedLatitude;
        this.longitude = this.selectedLongitude;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  onSubmit() {
    this.dialog.close({
      addressSearched: this.searchElementRef.nativeElement.value,
      address: this.address,
      latitude: this.latitude,
      longitude: this.longitude
    });
  }
}
